module.exports = __webpack_public_path__ + "assets/img/diarybook.f798d361.svg";